import { render, staticRenderFns } from "./historico.vue?vue&type=template&id=504be5c2&scoped=true"
import script from "./historico.vue?vue&type=script&lang=js"
export * from "./historico.vue?vue&type=script&lang=js"
import style0 from "./historico.vue?vue&type=style&index=0&id=504be5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504be5c2",
  null
  
)

export default component.exports